import React from "react";
import clsx from "clsx";
import Assets from "imports/assets.import";
import PrimaryButton from "common_components/ui/primary_button/primary_button.ui";
import { STRINGS } from "constants/strings.constant";
import { ButtonTypes } from "utils/interface.utils";
import { EditorNextStepProps } from "interfaces/editor_next_step.interface";
import "./editor_next_step.component.scss";

const TITLE_ID = "editor_next_step_title";

// The card over the canvas that the Objects "+" opens before the chooser, for a target's first object. The editor screen decides what
// "Add object" does (close this card and open the chooser).
const EditorNextStep = (props: EditorNextStepProps) => {
    const { onAddObject, className } = props;
    const strings = STRINGS.editor.nextStep;

    return (
        <section className={clsx("editor_next_step", className)} aria-labelledby={TITLE_ID}>
            <h2 id={TITLE_ID} className="editor_next_step__title">{strings.title}</h2>
            <p className="editor_next_step__description">{strings.description}</p>
            <div className="editor_next_step__action">
                <PrimaryButton
                    text={strings.addObject}
                    left_icon={Assets.plus}
                    iconSize={{ width: 20, height: 20 }}
                    type={ButtonTypes.PRIMARY_GRADIENT}
                    className="editor_next_step__button"
                    onClick={onAddObject}
                />
            </div>
        </section>
    );
};

export default EditorNextStep;
